// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2E07H","content":"styles_content__3SShR","checkbox":"styles_checkbox__3CZDe","checkboxLabel":"styles_checkboxLabel__3AqyI"};